export default {
  page: {
    header: {
      add_employee: 'Mitarbeiter hinzufügen',
      employees: 'Mitarbeiter',
      users: 'user',
      couriers: 'Außendienst',
      area_managers: 'Gebietsleitung',
      deputy_managers: 'Stellvertretende Gebietsleitung',
      admins: 'Administration',
      input_search: 'Suche',
      input_search_route: 'Suche',
      input_search_route_name: 'Suche (Rayonnummer)',
      routes: 'Rayone',
      assign_area_manager: 'Assign area manager',
      payments: 'Abrechnung',
      calendar_setings: 'Kalendereinstellung',
      leaves: 'Abwesenheiten',
      complaints: 'Reklamationen',
      profile: 'Profil',
      work_logs: 'Tätigkeitsaufzeichnung',
    },
    complaints: {
      deliveries_today: 'Anzahl Zeitungen heute',
      rate_today: 'Anzahl Reklamationen heute',
      rate_year: 'Reklamationsrate heute',
    },
    journeys: {
      total_completed: 'Tätigkeiten Gesamt',
      costs_month: 'Kosten',
      total_costs: 'Gesamtkosten',
      income_of: 'Betrag',
      total_income: 'Gesamtbetrag',
    },
  },
  table: {
    header: {
      name: 'Name',
      id: 'ID',
      email: 'E-Mail',
      phone: 'Telefon',
      area: 'Gebiet',
      status: 'Status',
      supervisor: 'Supervisor',
      date_added: 'Hinzugefügt am',
      last_active: 'Zuletzt aktiv',
      from: 'Von',
      to: 'Bis',
      amount_hours: 'Stunden',
      number: 'Rayonnummer',
      area_manager: 'Gebietsleitung',
      time_planned_seconds: 'Plandauer (h)',
      distance: 'Plandistanz (km)',
      date: 'Datum',
      type: 'Kategorie',
      employee: 'Mitarbeiter',
      payout: 'Betrag',
      number_route: 'Rayonnummer',
      complaint_rate: 'Reklamationsrate',
      number_complaints: 'Anzahl Reklamationen',
      newspapers_delivered: 'Anzahl Zeitungen',
      type_employee: 'Rolle',
      remaining_leave: 'Urlaubsanspruch',
      requested_leave: 'Urlaubsanfrage',
      leave: 'Abwesenheit',
      open_requests: 'Offene Anfragen',
    },
    pagination: {
      prev_text: 'zurück',
      next_text: 'weiter',
    },
    active_text: 'aktiv',
    no_active_text: 'inaktiv',
    delete_admin: 'Wollen Sie folgenden Mitarbeiter aus dem System löschen?',
    waiting_uproval: 'Freigabe offen',
    confirmed: 'freigegeben',
    rejected: 'abgelehnt',
    comment: 'Kommentar',
  },
  type_group: {
    title: 'Mitarbeiterrolle',
    courier: {
      title: 'Außendienst',
      text: 'Verantwortlich für die Zustellung',
    },
    area_manager: {
      title: 'Gebietsleitung',
      text: 'Verantwortlich für die Koordination der Zustellung',
    },
    admin: {
      title: 'Administration',
      text: 'Verantwortlich für die Verwaltung',
    },
    deputy_area_manager: {
      title: 'GL-STV',
    },
  },
  status: {
    in_progress: 'In Arbeit',
    waiting_uproval: 'Freigabe offen',
    approved_area_manager: 'GL Freigabe',
    approved_admin: 'HZ Freigabe',
    rejected: 'Abgelehnt',
    approved_automatically: 'System Freigabe',
    cancelled: 'Storniert',
  },
  info_route: {
    route: 'Rayon',
    custom: 'Benutzerdefiniert',
    amount: 'Betrag',
    drived: 'Fahrt (KM)',
    license_plate: 'Kennzeichen',
    type_journey: 'Kategorie',
    category: 'Route',
    mileage_exceeded: 'Abweichung',
  },
  holidays: {
    title: 'Feiertage',
    add: 'Hinzufügen',
    date: 'Datum',
    name: 'Beschreibung',
    year: 'Jahr',
    empty_title: 'Noch keine Feiertage im System',
    empty_text: 'Der neue Feiertag wird auf die Arbeitszeiten aller Mitarbeiter angewendet'
  }
}
